import * as React from 'react';

import type { HiveClient } from '@gitbook/hive-client';

import { HiveContext } from './HiveContext';

/**
 * Get the current HiveClient.
 */
export function useHiveClient(): HiveClient {
    const client = React.useContext(HiveContext);

    if (!client) {
        throw new Error('No HiveClient provided. Wrap your app with <HiveProvider>');
    }

    return client;
}
